import Vue from 'vue'

const eventBus = new Vue({
    data: {
        LOADING: {
            START: 'LOADING_START',
            END: 'LOADING_END'
        },
        SEND_LOG: 'SEND_LOG',
        SHOW_NOTIF: 'SHOW_NOTIF'
    }
});

export default eventBus;
